// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Kcze","rootSuccess":"CompleteLink_rootSuccess__1GvGw","rootFailure":"CompleteLink_rootFailure__2raLJ","isDisabled":"CompleteLink_isDisabled__Ro1AI"};